import { createContext, useContext } from 'react'

export const EmbedDepthContext = createContext(0)

export const useEmbedDepth = () => useContext(EmbedDepthContext)

export const getMaxEmbedDepth = () => window.hallway?.universe?.maxEmbedDepth ?? 2
